import { render, staticRenderFns } from "./brief2.vue?vue&type=template&id=b77c4b8e&scoped=true&"
import script from "./brief2.vue?vue&type=script&lang=js&"
export * from "./brief2.vue?vue&type=script&lang=js&"
import style0 from "./brief2.vue?vue&type=style&index=0&id=b77c4b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c4b8e",
  null
  
)

export default component.exports